// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js"}[chunkId] + "-" + {"125":"4b0096c8cf41e6907837","223":"1441c174163776f8386a","293":"1ef522978722abbc95eb","771":"78904b47a98d42c7d6a4"}[chunkId] + ".js";
};